import {
  Box,
  Icon,
  IconButton,
  ListItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { listIcons } from "./listIcons";
import { Search } from "@mui/icons-material";

interface PropsSelectIcon {
  icon?: string;
  iconColor?: string;
  bgColor?: string;
  iconSize?: number;
  onChoose?: (icon: string) => void;
}

export const SelectIcon: React.FC<PropsSelectIcon> = ({ icon, iconColor, iconSize, bgColor, onChoose }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [iconName, setIconName] = useState<string>(icon ?? "Abc");
  const [icons, setIcons] = useState<{ [key: string]: string; }>(listIcons);
  const [chooseText, setChooseText] = useState<string>();

  useEffect(() => {
    if (!chooseText || chooseText === "") {
      setIcons(listIcons);
      return;
    }

    const text = chooseText.replaceAll(" ", "");

    const starts: { [key: string]: string; } = {};
    const contains: { [key: string]: string; } = {};
    const ends: { [key: string]: string; } = {};

    for (const key of Object.keys(listIcons)) {
      if (key.toUpperCase().startsWith(text.toUpperCase())) {
        starts[key] = listIcons[key];
      } else if (key.toUpperCase().endsWith(text.toUpperCase())) {
        ends[key] = listIcons[key];
      } else if (key.toUpperCase().includes(text.toUpperCase())) {
        ends[key] = listIcons[key];
      }
    }

    setIcons({
      ...starts,
      ...contains,
      ...ends,
    });
  }, [chooseText]);

  const handleText = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChooseText(event.target.value);
  };

  const elementsPerLine = 5;

  return <>
    <Modal
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
    >
      <Box sx={{
        width: '596px',
        height: "80vh",
        bgcolor: 'background.paper',
        position: 'absolute',
        borderRadius: "15px",
        padding: "15px",
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: 24,
      }}>
        {/* Tabela de dados e filtro*/}
        <AutoSizer>
          {({ height, width }: { height: number; width: number; }) => {
            return <>
              {/* Search */}
              <Box sx={{
                width: width,
                height: "56px",
                display: "flex",
                flexDirection: "row",
              }}>
                <TextField
                  label="Filtrar"
                  variant="standard"
                  value={chooseText}
                  onChange={handleText}
                  fullWidth
                />
                <div style={{ width: "15px" }} />
                <Search />
              </Box>
              <div style={{ height: "15px" }} />

              {/* Lista de dados */}
              <FixedSizeList
                height={height - 56 - 15}
                width={width}
                itemSize={126}
                itemCount={Math.ceil(Object.keys(icons).length / elementsPerLine)}
                overscanCount={5}
              >
                {({ style, index }: ListChildComponentProps) => {
                  return <ListItem
                    style={style}
                    key={index}
                    component="div"
                  >
                    {Array.from({ length: elementsPerLine }, (_, i) => i).map((iElem) => {
                      const indexIcone = (index * elementsPerLine) + iElem;
                      const name = Object.keys(icons)[indexIcone];

                      if (!name) {
                        return <Box
                          key={`${index}-${iElem}`}
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            height: style.height ?? "126px",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            paddingTop: "15px",
                            justifyContent: "start",
                            alignItems: "center",
                          }} />;
                      }

                      const iconName = name.split('')
                        .map((char, index) => (/[A-Z]/.test(char) && index > 0 ? ' ' + char : char))
                        .join('');

                      return <Box
                        key={`${index}-${iElem}`}
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          height: style.height ?? "126px",
                          paddingLeft: "15px",
                          paddingRight: "15px",
                          paddingTop: "15px",
                          justifyContent: "start",
                          alignItems: "center",
                        }}>
                        <IconButton
                          sx={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "56px",
                            bgcolor: "#00000033",
                            color: iconColor ?? "#000",
                          }}
                          onClick={() => {
                            setAnchorEl(null);
                            setIconName(name);
                            if (onChoose) onChoose(name);
                          }}
                        >
                          <Icon>
                            {icons[name]}
                          </Icon>
                        </IconButton>
                        <Typography
                          align={"center"}
                          fontSize={10}
                          fontWeight={"bold"}
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            WebkitLineClamp: 3,
                          }}
                        >
                          {iconName}
                        </Typography>
                      </Box>;
                    })}
                  </ListItem>;
                }}
              </FixedSizeList>
            </>;
          }
          }
        </AutoSizer >
      </Box >
    </Modal >

    {/* Botão */}
    < IconButton
      onClick={(event) => setAnchorEl(event.currentTarget)}
      sx={{
        color: iconColor,
        bgcolor: bgColor,
      }}
    >
      <Icon sx={{ fontSize: iconSize }}>
        {icons[iconName]}
      </Icon>
    </IconButton >

  </>;
};